(function ($) {
    "use strict";
    loadMore();
})(jQuery);

function loadMore(event, element) {
    $('a.js-load-more').click(function (e) {
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.parent();
        let params = new URLSearchParams(document.location.search);
        let pageIndex = parseInt($this.data("next-page") ?? 0);
        let filterIndex = $('.resource-filter.active');
        let ajaxUrl = $('#load-more-url').data('load-more');

        params.set("p", pageIndex);
        if(filterIndex.length){
            params.set('topic', filterIndex.data('filter-id'));
        }

        $.ajax({
            url: `${ajaxUrl}LoadMore?${params.toString()}`,
            success: function (html) {
                $parent.replaceWith(html);
                loadMore();
            },
            error: function (error) {
                console.log(error.responseText);
            }
        });
        setTimeout(function() { 
            singleClickInit();
        }, 1750);

    });
}

// duplicated from main.js
function singleClickInit() {
    $('.single-click').each(function () {
        var $this = $(this),
            imgLink = $this.find('a img'),
            down,
            up,
            link = $this.find('a'),
            middleClick,
            linkClick,
            auxClick;

        if (imgLink.length) {
            imgLink.unwrap();
        }

        if (!link.length || link.length > 1) {
            $this.removeClass('single-click');
        }
        else
        {
            $this.on('mousedown', function (e) {
                down = +new Date();
                middleClick = (e.which === 2) ? true : false;
                auxClick = (e.which === 3) ? true : false;
            
                // Prevent two tabs from opening in firefox
                linkClick = $(e.target).is('a') ? false : true;
            }).on('mouseup', function () {
                up = +new Date();
                if ((up - down) < 200 && auxClick === false && linkClick === true) {
                    link[0].click();
                }
            });
        }
    });
}